module.exports = {
      id: "ic-highest-lowest-light-normal-usage",
      viewBox: "0 0 160 120",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#ic-highest-lowest-light-normal-usage",
      toString: function () {
        return this.url;
      }
    }